import * as React from "react";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Modal(props) {
  const { open = false } = props;

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={props.onClose}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar sx={{ backgroundColor: props.color }}>
          <IconButton
            edge="start"
            color="inherit"
            disabled={props.disableCloseButton}
            onClick={props.onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography
            sx={{ color: "white", fontWeight: "bold", marginTop: "4px" }}
            variant="button"
            display="block"
            gutterBottom
          >
            {props.name}
          </Typography>
        </Toolbar>
      </AppBar>
      {props.children}
    </Dialog>
  );
}
